/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Price_Per_KgInputs */

const en_fix_price_per_kg = /** @type {(inputs: Fix_Price_Per_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price per kg (€)`)
};

const de_fix_price_per_kg = /** @type {(inputs: Fix_Price_Per_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis pro kg (€)`)
};

/**
* | output |
* | --- |
* | "Price per kg (€)" |
*
* @param {Fix_Price_Per_KgInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_price_per_kg = /** @type {((inputs?: Fix_Price_Per_KgInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Price_Per_KgInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_price_per_kg(inputs)
	return en_fix_price_per_kg(inputs)
});